export default __webpack_public_path__ + "static/media/Utric's Just Blade.3b3bb0d5.jpg";